export default __webpack_public_path__ + "static/media/ourstory_image_4.62fc98d4.png";